module.exports = __webpack_public_path__ + "img/to.cccdba4c.svg";